module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservations-tabs__container"
  }, [_c('ul', {
    staticClass: "micro-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: tab.id === _vm.selected
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.onSelect(tab.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.label) + "\n        ")])
  }), 0)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-31c76cb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c76cb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/ReservationsTabs.vue
// module id = 2786
// module chunks = 0